// extracted by mini-css-extract-plugin
module.exports = {"photoWrapper":"UserPhoto_photoWrapper__20Wg_","photo":"UserPhoto_photo__N7ZMX","noPhoto":"UserPhoto_noPhoto__O0kTV","buttons":"UserPhoto_buttons__1EYGs"};